import debounce from 'lodash/debounce';
import {useRouter} from 'next/router';
import {useEffect, useMemo, useState} from 'react';
import useTypedDispatch from '../../../common/useTypedDispatch';
import {setOpenAutoComplete, setSearchkeyword} from '../state/searchSlice';

export function useSearchInputKeyword() {
  const dispatch = useTypedDispatch();
  const {query} = useRouter();
  const [keyword, setKeyword] = useState(
    (query.keyword as string | undefined) || ''
  );

  /**
   * 페이지 첫 진입시 query.keyword가 있을 경우(키워드 검색 결과 페이지) local state인 keyword를 업데이트합니다.
   */
  useEffect(() => {
    const queryKeyword = query.keyword ? (query.keyword as string) : '';
    setKeyword(queryKeyword);
    dispatch(setSearchkeyword(queryKeyword));
    !queryKeyword && dispatch(setOpenAutoComplete(false));
  }, [dispatch, query]);

  const debouncedOnChangeKeyword = useMemo(
    () =>
      debounce((searchKeyword: string) => {
        if (!searchKeyword) {
          dispatch(setSearchkeyword(''));
          dispatch(setOpenAutoComplete(false));
          return;
        }
        dispatch(setOpenAutoComplete(true));
        dispatch(setSearchkeyword(searchKeyword));
      }, 500),
    [dispatch]
  );

  return {
    inputKeyword: keyword,
    setInputKeyword: setKeyword,
    debouncedOnChangeInputKeyword: debouncedOnChangeKeyword,
  };
}
